import React from 'react'
// import Logo from '../images/logo.svg'
import Fb from '../images/icon-facebook.svg'
import Instagram from '../images/icon-instagram.svg'
import Twitter from '../images/icon-twitter.svg'
import Pinterest from '../images/icon-pinterest.svg'

function Footer() {
  return (
    <div className="container bg-Very-Dark-Violet text-Grayish-Violet px-16 py-12 md:text-left text-center">
        <div className="flex flex-col sm:flex-row justify-center">
            <div className="flex-1">
                <a href="/" className='text-3xl font-extrabold text-white'>Shortly</a>
            </div>
            <div className="flex-1">
                <h1 className='font-bold text-x text-white'>Features</h1>
                <ul className="footer-items py-4">
                    <li className="footer-item py-1 hover:text-cyan"><a href="/" className="footer-link">Link shortening</a></li>
                    <li className="footer-item py-1 hover:text-cyan"><a href="/" className="footer-link">Branded links</a></li>
                    <li className="footer-item py-1 hover:text-cyan"><a href="/" className="footer-link">Analytics</a></li>
                </ul>
            </div>
            <div className="flex-1">
                <h1 className='font-bold text-x text-white'>Resources</h1>
                <ul className="footer-items py-4">
                    <li className="footer-item py-1 hover:text-cyan"><a href="/" className="footer-link ">Blog</a></li>
                    <li className="footer-item py-1 hover:text-cyan"><a href="/" className="footer-link ">Developers</a></li>
                    <li className="footer-item py-1 hover:text-cyan"><a href="/" className="footer-link ">Support</a></li>
                </ul>
            </div>
            <div className="flex-1">
                <h1 className='font-bold text-x text-white'>Company</h1>
                <ul className="footer-items py-4">
                    <li className="footer-item py-1 hover:text-cyan"><a href="/" className="footer-link ">About</a></li>
                    <li className="footer-item py-1 hover:text-cyan"><a href="/" className="footer-link ">Our Teams</a></li>
                    <li className="footer-item py-1 hover:text-cyan"><a href="/" className="footer-link ">Contacts</a></li>
                </ul>
            </div>
            <div className="flex-1">
                <ul className="footer-items flex">
                    <li className="footer-item mx-2"><a href="/" className="footer-link py-6 "><img src={Fb} alt=""  className='hover:bg-cyan rounded' /></a></li>
                    <li className="footer-item mx-2"><a href="/" className="footer-link py-6"><img src={Twitter} alt=""  className='hover:bg-cyan rounded'/></a></li>
                    <li className="footer-item mx-2"><a href="/" className="footer-link py-6"><img src={Pinterest} alt=""  className='hover:bg-cyan rounded'/></a></li>
                    <li className="footer-item mx-2"><a href="/" className="footer-link py-6"><img src={Instagram} alt="" className='hover:bg-cyan rounded' /></a></li>
                </ul>
            </div>
        </div>
    </div>
  )
}

export default Footer